export type StoryChoice = {
  label: string;
  isCorrect: boolean;
};

export type StoryScene = {
  id: string;
  image?: string;
  audio?: string;
  video?: string;
  text?: string;
  choices?: StoryChoice[];
};

export type InteractiveStory = {
  id: string;
  title: string;
  startSceneId: string;
  scenes: StoryScene[];
};

const storyImage = (fileName: string) =>
  `${process.env.PUBLIC_URL || ""}/story/forest-rescue/${fileName}`;

const hiddenPages = new Set([5]);

export const forestRescueStory: InteractiveStory = {
  id: "forest-rescue-team",
  title: "Forest Rescue Team",
  startSceneId: "scene-01",
  scenes: Array.from({ length: 26 }, (_, index) => index + 1)
    .filter((page) => !hiddenPages.has(page))
    .map((page) => {
    const pageNumber = String(page).padStart(2, "0");
    const id = `scene-${pageNumber}`;
    const scene: StoryScene = {
      id,
      image: storyImage(`${id}.jpg`),
    };

    if (page === 9) {
      return {
        ...scene,
        audio: "https://www.pkps.edu.hk/video/ebook.mp4",
      };
    }

    if (page === 13) {
      return {
        ...scene,
        choices: [
          { label: "Max Monkey", isCorrect: true },
          { label: "Danny Dog", isCorrect: false },
        ],
      };
    }

    if (page === 16) {
      return {
        ...scene,
        choices: [
          { label: "Danny Dog", isCorrect: true },
          { label: "Gigi Giraffe", isCorrect: false },
        ],
      };
    }

    if (page === 19) {
      return {
        ...scene,
        choices: [
          { label: "Eddie Elephant", isCorrect: true },
          { label: "Gigi Giraffe", isCorrect: true },
        ],
      };
    }

    return scene;
  }),
};
